import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import Meta from '../components/Meta';
import './AboutUs.css';
import '../Animations.css';
import './Shared.css';
import foto2 from '../assets/foto2.webp';

function AboutUs() {
  const { t } = useTranslation(); // Initialize useTranslation
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const methodSteps = t('about_us_page.method_steps', { returnObjects: true });
  const valuesItems = t('about_us_page.values_items', { returnObjects: true });

  return (
    <div className="about-us-page">
      <Meta title={t('about_us_page.meta_title')} description={t('about_us_page.meta_description')} />
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>{t('about_us_page.hero_title')}</h1>
          <p>{t('about_us_page.hero_subtitle')}</p>
        </div>
      </section>

      <section className="section-container">
        <h2>{t('about_us_page.history_title')}</h2>
        <div className="content-with-image">
          <div className="text-content">
            <p>{t('about_us_page.history_text_p1')}</p>
            <p>{t('about_us_page.history_text_p2')}</p>
          </div>
          <div className="image-content">
            <img src={foto2} alt={t('about_us_page.history_title')} />
          </div>
        </div>
      </section>

      <section
        className="section-container light-background light-background-with-image fade-in-section"
        ref={(el) => (sectionsRef.current[0] = el)}
      >
        <h2>{t('about_us_page.method_title')}</h2>
        <p>{t('about_us_page.method_subtitle')}</p>
        <div className="method-steps">
          {methodSteps.map((step, index) => (
            <div key={index} className="step-item">
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-container">
        <h2>{t('about_us_page.values_title')}</h2>
        <div className="values-grid">
          {valuesItems.map((value, index) => (
            <div key={index} className="value-item">
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section
        className="section-container light-background light-background-with-image fade-in-section"
        ref={(el) => (sectionsRef.current[1] = el)}
      >
        <h2>{t('about_us_page.promise_title')}</h2>
        <p className="promise-text">{t('about_us_page.promise_text')}</p>
      </section>
    </div>
  );
}

export default AboutUs;
